import { ControlGroup, NumericInput } from '@blueprintjs/core'
import cn from 'classnames'
import React, { useEffect, useMemo, useState } from 'react'
import { TextInput } from '../../../components/inputs/Input'
import { Button } from '../../../components/ui/button'

interface EditableFieldProps {
    className?: any
    value: any
    onChange: any
    loading: boolean
    rightIcon?: any
    leftIcon?: any
    type?: any
    disabled?: boolean
}

const style = { width: '100px' }

export const EditableField = ({
    className = '',
    value,
    onChange,
    loading,
    rightIcon = '',
    leftIcon = 'default',
    type = 'number',
    disabled = false,
}: EditableFieldProps) => {
    const [dirty, setDirty] = useState(value)
    const isDirty = useMemo(() => {
        return value !== dirty
    }, [value, dirty])

    useEffect(() => {
        setDirty(value)
    }, [value])

    if (leftIcon === 'default') {
        leftIcon = <Button minimal text={window.marketplace.currency_symbol} />
    }

    const commit = () => {
        onChange(dirty)
    }

    const onKeyDown = (e: any) => {
        if (e.key == 'Enter') {
            commit()
        } else if (e.key == 'Escape') {
            setDirty(value)
        } else {
            return e
        }
    }

    return (
        <div className={cn('d-flex relative')}>
            {type === 'number' && (
                <NumericInput
                    className={className}
                    style={style}
                    disabled={loading || disabled}
                    minorStepSize={0.01}
                    stepSize={0.01}
                    majorStepSize={0.01}
                    leftIcon={leftIcon}
                    rightElement={rightIcon}
                    value={dirty}
                    onValueChange={(_, value) => setDirty(value)}
                    onKeyDown={onKeyDown}
                    buttonPosition="none"
                />
            )}
            {type === 'text' && (
                <TextInput
                    className={className}
                    disabled={loading || disabled}
                    prefix={leftIcon}
                    suffix={rightIcon}
                    value={dirty ?? ''}
                    onChange={setDirty}
                    onKeyDown={onKeyDown}
                />
            )}
            {isDirty && (
                <div className="z-10 relative bp4-control-group">
                    <ControlGroup
                        className="flex absolute bp4-control-group"
                        style={{ float: 'right' }}
                    >
                        <Button loading={loading} icon="tick" intent="primary" onClick={commit} />
                        <Button
                            disabled={loading || disabled}
                            icon="cross"
                            onClick={() => setDirty(value)}
                        />
                    </ControlGroup>
                </div>
            )}
        </div>
    )
}
